<template>
  <section
    ref="textintro2"
    class="slide3 flex flex-col justify-center min-h-screen pb-8 lg:pb-0 bg-workbook-blue relative overflow-hidden"
  >
    <GraphicsTable
      class="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-1/12 md:-translate-x-1/2 md:-translate-y-1/12"
    />
    <UContainer class="flex z-20">
      <UPageGrid>
        <div class="text-white col-span-5 lg:col-span-5 flex flex-col justify-center">
          <h1 class="text-4xl md:text-6xl font-normal mb-12 mt-32 lg:mt-0">
            Why Kudo Sales?
          </h1>
          <p>
            Kudo Sales turns your collection into a living sales workbook — combining visual sell-in with built-in ordering. 
            
          </p>
          <p>
            Export presentation-ready PDFs directly from the workbook, always synced with your data.
          </p>
          <p>
            Flexible to work with. <br/> Easy to sell from.
            
          </p>
        </div>
        <div class="laptop col-span-4 lg:col-span-7 overflow-hidden pb-0">
          <TwicImg 
          :src="'/images/intro/laptop-home.png' + '?deployment=' + config.public.appVersion"
          ratio="100/60" intrinsic="1716x1038" mode="contain"
            placeholder="none" />
        </div>
      </UPageGrid>
    </UContainer>
    <WorkbookImageCarousel
      class="mt-20 lg:mt-5"
      folder="images/caseslides"
      :slides="7"
      proportions="406/266"
      intrinsic="202x133"
    />
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'

import { useWindowSize } from '@vueuse/core'
import { loadGsap } from '@/utils/gsap'

import { useRuntimeConfig } from '#app'

const config = useRuntimeConfig()


const textintro2 = ref<HTMLElement | null>(null)
let ctx: gsap.Context | null = null

const { width } = useWindowSize()
const isLgUp = computed(() => width.value >= 1024)

onMounted(async () => {
  if (!process.client) return

  const { gsap } = await loadGsap()

  const h1 = textintro2.value?.querySelector('h1')
  const pElements = textintro2.value?.querySelectorAll('p') || []
  const laptop = textintro2.value?.querySelector('.laptop')

  if (h1 && pElements.length > 0 && textintro2.value && laptop) {
    ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: textintro2.value,
          pin: false,
          markers: false,
          start: 'top 55%',
          end: 'top 10%',
          scrub: 2,
          snap: {
            snapTo: 'labels',
            duration: { min: 0.2, max: 3 },
            delay: 0.2
          }
        }
      })

      const tlaptop = gsap.timeline({
        scrollTrigger: {
          trigger: textintro2.value,
          pin: false,
          markers: false,
          start: 'top 75%',
          end: 'top 0%',
          scrub: true
        }
      })

      const endx = isLgUp.value ? -130 : 0
      tl.fromTo(h1, { opacity: 0 }, { opacity: 1, duration: 3 })
      tl.fromTo(pElements, { opacity: 0 }, { opacity: 1, duration: 3, stagger: 3 }, '-=2')

      tlaptop.fromTo(laptop, { y: -80, opacity: 0 }, { y: -10, opacity: 1, duration: 6 })
      tlaptop.to(laptop, { x: endx, duration: 3 }, '=-3')
    }, textintro2.value || undefined)
  }
})

onUnmounted(() => {
  ctx?.revert()
  ctx = null
})
</script>

<style scoped>
@reference "../../assets/css/main.css";

p {
  @apply text-xl lg:text-2xl;
}

.slide3 {
  background-size: auto 100%;
  background-position: 0% 100%;
  background-repeat: no-repeat;
}
</style>
